/*
 * create by wq on 2021/07/05
 * */

// 引入样式文件
import '../css/panel-notify.less';
import websocket from '../../../scripts/common/websocket.js';

 //获取缓存中的blocks，判断是否已购买热点发现、线索汇聚、传播分析
 var blocks = JSON.parse(window.localStorage.getItem('blocks'));
 var hasClueService = false,
   cluePath = void 0;
 var hasHotService = false,
   hotPath = void 0;
 var hasAnalysisService = false,
   analysisPath = void 0;
 $(blocks).each(function (i, v) {
   if (v.appId === 300) {
     hasHotService = true;
     hotPath = v.path;
   }
   if (v.appId === 400) {
     hasClueService = true;
     cluePath = v.path;
   }
   if (v.appId === 500) {
     hasAnalysisService = true;
     analysisPath = v.path;
   }
 });

 /*
  * 跳转到线索、热点、传播分析的loading页面，参数如下
  * system为clue、hot、analysis
  * hasService是否有此服务，true、false
  * path为跳转的loading路径
  * actualUrl为实际要跳转的地址，格式类似‘/hotEvents/hot-events-analyse.html’，
  * openNewWindow是否打开新窗口，true、false
  * */
 function jumpToOtherSystem(
   system,
   hasService,
   path,
   actualUrl,
   openNewWindow
 ) {
   //判断是否购买了线索、热点、传播分析，如果没有购买则提示用户
   if (system === 'clue' && !hasService) {
     boxMessage('warning', '您尚未购买线索汇聚，请联系管理员。');
     return;
   }
   if (system === 'hot' && !hasService) {
     boxMessage('warning', '您尚未购买热点发现，请联系管理员。');
     return;
   }

   if (system === 'analysis' && !hasService) {
     boxMessage('warning', '您尚未购买传播分析，请联系管理员。');
     return;
   }

   //根据不同的系统跳转不同的loading
   var jumpLoadingUrl = void 0;
   jumpLoadingUrl =
     '//' +
     window.location.host +
     path +
     '?actualUrl=' +
     encodeURIComponent(actualUrl);

   //根据是否新开页面来执行跳转
   if (openNewWindow) {
     window.open(jumpLoadingUrl);
   } else {
     window.location.href = jumpLoadingUrl;
   }
 }

//创建构造函数PanelNotify
var PanelNotify = function (options) {
  this.options = options;
};

PanelNotify.prototype = {
  init: function (options) {
    $('body').append(
      `<ul class="panel-notify-list" id="panelNotifyList"></ul>`
    );
    websocket.on('new_tip', function (data) {
      let msg = data.msg || {};

      $('#panelNotifyList').prepend(
        `<li class="panel-notify-item" id="${
          'notify-' + msg.panelId
        }" data-resource-id="${msg.resourceId}" data-panel-id="${msg.panelId}">
          <div class="ico-notify"></div>
          <div class="notify-content">
            <h3 class="omit-words omit-words-2">${msg.title || msg.summary}</h3>
            <div class="notify-info">
              <span>${data.createTime}</span>
              <span>${msg.mediaName}</span>
            </div>
          </div>
        </li>`
      );
      setTimeout(() => {
        $(`#notify-${msg.panelId}`).remove();
      }, 10000);
      $('#panelNotifyList').off('click').on('click', '.panel-notify-item', function () {
        let panelId = $(this).data('panelId');
        let resourceId = $(this).data('resourceId');
        
        jumpToOtherSystem(
          'clue',
          hasClueService,
          cluePath,
          `/panel/panel-detail.html?panelId=${panelId}&resourceId=${resourceId}`,
          true
        );
      });
    });
  },
};

export default PanelNotify;
